import { CalendarErrors } from '../../../../utils/bi/consts';
import { ViewModelFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarState, TFunction } from '../../controller';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import settingsParams from '../../settingsParams';
import { FlowElements } from '../../Hooks/useFlow';
import { MemoizedViewModalFactory } from '../viewModel';
import {
  createEmptyStateViewModel,
  EmptyStateViewModel,
} from '../emptyStateViewModel/emptyStateViewModel';

export enum BottomSectionStatus {
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

export type WidgetViewModel = {
  status: BottomSectionStatus;
  dateAndTimeSectionHeaderText: string;
  bookingDetailsSectionHeaderText: string;
  notificationText: string;
  focusedElement?: FlowElements;
  emptyStateViewModel?: EmptyStateViewModel;
};

export const memoizedWidgetViewModel: MemoizedViewModalFactory<WidgetViewModel> = {
  dependencies: {
    state: ['calendarErrors', 'focusedElement', 'bottomSectionStatus'],
    settings: ['dateAndTimeSectionHeader', 'bookingDetailsSectionHeader'],
  },
  createViewModel: createWidgetViewModel,
};

export function createWidgetViewModel({
  state,
  context: { getContent, t, settings },
}: ViewModelFactoryParams<CalendarState, CalendarContext>): WidgetViewModel {
  const {
    calendarErrors,
    focusedElement,
    bottomSectionStatus,
    initialErrors,
  } = state;

  let emptyStateViewModel;
  if (initialErrors.length > 0) {
    emptyStateViewModel = createEmptyStateViewModel({
      t,
      type: initialErrors[0],
    });
  }

  const notificationText = getNotificationText(calendarErrors, t);

  return {
    status: bottomSectionStatus,
    dateAndTimeSectionHeaderText: getContent({
      settingsParam: settingsParams.dateAndTimeSectionHeader,
      translationKey: 'app.settings.defaults.widget.date-and-time-header',
    }),
    bookingDetailsSectionHeaderText: getContent({
      settingsParam: settingsParams.bookingDetailsSectionHeader,
      translationKey: 'app.settings.defaults.widget.booking-details-header',
    }),
    notificationText,
    focusedElement,
    emptyStateViewModel,
  };
}

const getNotificationText = (
  calendarErrors: CalendarErrors[],
  t: TFunction,
) => {
  if (
    calendarErrors.includes(
      CalendarErrors.SELECTED_SLOT_VALIDATION_NO_TIME_SELECTED_ERROR,
    )
  ) {
    return t('app.notification.no-time-selected-error.text');
  }
  return '';
};
